import { forwardRef, useMemo } from 'react'
import { ChartLegend } from './ChartLegend'
import { buildDumbbellOption, dumbbellColors, dumbbellHeight, type DumbbellInput, type DumbbellRow } from './dumbbellOption'
import { EChart, type EChartHandle } from './EChart'
import { useChartTheme } from './useChartTheme'

export interface DumbbellProps extends DumbbellInput {
  height?: number
  loading?: boolean
  ariaLabel?: string
  className?: string
  /** Клик по строке (точкам или подписи) — обычно панель детализации объекта. */
  onRowClick?: (row: DumbbellRow) => void
}

/** «Было → стало» по объектам: две точки одной гаммы на общей оси, Δ справа подписью. */
export const Dumbbell = forwardRef<EChartHandle, DumbbellProps>(function Dumbbell(
  { height, loading, ariaLabel, className, onRowClick, ...input },
  ref,
) {
  const theme = useChartTheme()
  const option = useMemo(
    () => buildDumbbellOption(input, theme),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [theme, input.rows, input.fromLabel, input.toLabel, input.valueFormat, input.showDelta, input.invertDelta, input.rowLabelWidth],
  )
  const colors = dumbbellColors(theme)
  return (
    <div className={className}>
      <ChartLegend
        items={[
          { label: input.fromLabel, color: colors.from },
          { label: input.toLabel, color: colors.to },
        ]}
        className="mb-2"
      />
      <EChart
        ref={ref}
        option={option}
        height={height ?? dumbbellHeight(input.rows.length)}
        loading={loading}
        ariaLabel={ariaLabel}
        onMarkClick={(params) => {
          if (params.componentType === 'yAxis') {
            const key = String(params.value ?? '')
            const row = key.startsWith('r') ? input.rows[Number(key.slice(1))] : undefined
            if (row) onRowClick?.(row)
            return
          }
          if (params.componentType !== 'series' || params.dataIndex === undefined) return
          const row = input.rows[params.dataIndex]
          if (row) onRowClick?.(row)
        }}
      />
    </div>
  )
})

export default Dumbbell
